<vectronic-card [title]="'Export Options'" [displayClose]="true" (closed)="dialogRef.close()">
  <ng-container body [formGroup]="exportOptionsForm">
    <div class="card-body">
      @if (data.hintText) {
        <p class="hint-text">{{ data.hintText }}</p>
      }
      <mat-form-field class="csv-separator" appearance="outline" disabled>
        <mat-label>CSV Separator</mat-label>
        <mat-select [formControlName]="'csvSeparator'">
          <mat-option [value]="','"> ,</mat-option>
          <mat-option [value]="';'"> ;</mat-option>
          <mat-option [value]="'&#9;'"> TAB</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-group" appearance="outline">
        <mat-label>Files: </mat-label>
        <mat-select [formControlName]="'isSingleFile'">
          <mat-option [value]="true"> Single File</mat-option>
          @if (!data.hideMultipleFile) {
            <mat-option [value]="false"> Multiple Files</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="button-container">
      <button mat-button color="warn" class="button reset-button" (click)="reset()">
        <mat-icon>cancel</mat-icon>
        Reset
      </button>
      <button mat-button color="accent" class="button apply-button" (click)="apply()">
        <mat-icon>file_download</mat-icon>
        Export
      </button>
    </div>
  </ng-container>
</vectronic-card>
